import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { State } from './subscriptions.types';
import {
  clearMessageKey,
  setAddOnScopeKey,
  setSubscriptionMessageKey,
} from './subscriptions.types';

export const initialState: State = {
  showMessageKey: undefined,
  addOnScopeKey: undefined,
};

const reducer = reducerWithInitialState<State>(initialState)
  .caseWithAction(setSubscriptionMessageKey, (state, action) => {
    return {
      ...state,
      showMessageKey: action.payload,
    };
  })
  .caseWithAction(setAddOnScopeKey, (state, action) => {
    return {
      ...state,
      addOnScopeKey: action.payload,
    };
  })
  .case(clearMessageKey, () => {
    return initialState;
  });

export default reducer;
